<template>
  <section class="page-section">
        <!-- 筛选 -->
        <div class="filter-region no-margin-top">
          <div class="filter-form">
            <el-form size="small" :inline="true" :model="filterForm" ref="filterForm">
              <el-form-item label="日期：" prop="orderTime" class="auto-width">
                <el-date-picker v-model="filterForm.time" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
                  start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item class="time-shortcut">
                <el-button plain @click="getLastFewDays(-7)"
                  :class="{ 'is-active': isActiveShortcut(-7) }">近7天</el-button>
                <el-button plain @click="getLastFewDays(-30)"
                  :class="{ 'is-active': isActiveShortcut(-30) }">近30天</el-button>
              </el-form-item>
              <el-form-item label="员工姓名：" prop="userId">
                <el-select v-model="filterForm.userId" placeholder="请选择">
                  <el-option label="全部" :value="null"></el-option>
                  <el-option v-for="(row, rowIndex) in employeeOptions" :label="row.name" :value="row.id"
                    :key="rowIndex"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="filter-btn">
            <el-button-group class="btn-group">
              <el-button plain class="btn-reset" icon="el-icon-refresh"
                @click="filterFormReset('filterForm')"></el-button>
              <el-button type="primary" class="btn-search" @click="filterFormSubmit('filterForm')"
                :loading="tableLoading">查询</el-button>
            </el-button-group>
          </div>
        </div>

        <!-- 统计 -->
        <div class="statistics" style="margin-top: 10px">
          <div>
            <span class="item">服务订单总金额：￥{{ statistics.serviceOrderAmount || 0 }}</span>
            <span class="item">商品订单总金额：￥{{ statistics.productOrderAmount || 0 }}</span>
          </div>
          <div style="margin-top: 20px;">
            <span class="item">服务订单总笔数：{{ statistics.serviceOrderNum || 0 }}</span>
            <span class="item">商品订单总笔数：{{ statistics.productOrderNum || 0 }}</span>
          </div>
          <div style="margin-top: 20px;">
            <span class="item">服务订单总收益：￥{{ (statistics.serviceOrderIncome || 0) }}</span>
            <span class="item">商品订单总收益：￥{{ (statistics.productOrderIncome || 0) }}</span>
          </div>
        </div>

        <!-- tabs -->
        <el-tabs v-model="tabName" type="card" @tab-click="handleTabsChange" style="margin-top: 20px">
          <el-tab-pane label="服务订单" name="1"></el-tab-pane>
          <el-tab-pane label="商品订单" name="2"></el-tab-pane>
        </el-tabs>


        <!-- tab list -->
        <div class="form-module">
          <div class="module-body">
            <!-- table -->
            <div class="table-region" v-loading="tableLoading">
              <template v-if="tabName == '1'">
                <!-- 服务订单统计 -->
                <div class="statistics default" style="margin-top: 10px">
                  <span class="item">服务订单总金额：￥{{ statistics.serviceOrderAmount || 0 }}</span>
                  <span class="item">服务订单总笔数：{{ statistics.serviceOrderNum || 0 }}</span>
                  <span class="item">服务订单总收益：￥{{ (statistics.serviceOrderIncome || 0) }}</span>
                </div>
              </template>
              <template v-if="tabName == '2'">
                <!-- 商品订单统计 -->
                <div class="statistics default" style="margin-top: 10px">
                  <span class="item">商品订单总金额：￥{{ statistics.productOrderAmount || 0 }}</span>
                  <span class="item">商品订单总笔数：{{ statistics.productOrderNum || 0 }}</span>
                  <span class="item">商品订单总收益：￥{{ (statistics.productOrderIncome || 0) }}</span>
                </div>
              </template>
              <!-- 订单列表 -->
              <el-table size="small" :data="tableData" style="margin-top: 20px">
                <el-table-column label="发放收益">
                  <template slot-scope="scope">
                    <p>+{{ scope.row.income }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="发放时间">
                  <template slot-scope="scope">
                    <p>{{ COMMON.formatDate('2', '-', scope.row.incomeTime) }}</p>
                  </template>
                </el-table-column>
                <el-table-column :label="tabName == '1' ? '项目' : '商品'">
                  <template slot-scope="scope">
                    <p>{{ scope.row.item }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="订单号">
                  <template slot-scope="scope">
                    <p>{{ scope.row.orderNumber }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="订单金额">
                  <template slot-scope="scope">
                    <p>{{ scope.row.orderAmount }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="订单成交时间">
                  <template slot-scope="scope">
                    <p>{{ COMMON.formatDate('2', '-', scope.row.orderCompletionTime) }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="下级顾客">
                  <template slot-scope="scope">
                    <p>{{ scope.row.subCustomer }}<template v-if="scope.row.subCustomerMobile">({{
                      scope.row.subCustomerMobile }})</template>
                    </p>
                  </template>
                </el-table-column>
                <el-table-column label="员工姓名">
                  <template slot-scope="scope">
                    <p>{{ scope.row.employeeName }}</p>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div class="table-footer" v-if="page.total > 0">
              <div class="selection-operate"></div>

              <div class="pagination-wrap">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                  :page-sizes="[20, 50, 100]" :pager-count="5" :current-page="page.current" :page-size="page.size"
                  layout="total, sizes, prev, pager, next, jumper" :total="page.total">
                </el-pagination>
              </div>
            </div>
            <!-- </div> -->
          </div>
        </div>

      </section>
</template>

<script>
import {
  COMMON,
  agentServiceOrderStatics,
  agentProductOrderStatics,
  agentOrderList,
  agentEmployeeList
} from '@/common/api';

export default {
  data() {
    return {
      COMMON,

      id: localStorage.getItem('companyId') && localStorage.getItem('companyId') !== 'null' ? localStorage.getItem('companyId') : null,

      filterForm: { // 筛选表单值
        time: [],
        userId: null
      },

      tabName: '1',

      tableData: [],
      tableLoading: false,
      page: { // 分页参数
        current: 1,
        size: 20,
        total: 0
      },

      statistics: {
        serviceOrderAmount: 0,
        serviceOrderNum: 0,
        serviceOrderIncome: 0,
        productOrderAmount: 0,
        productOrderNum: 0,
        productOrderIncome: 0
      },

      employeeLoading: false,
      employeeOptions: [],

      operatePermission: COMMON.getPermissionStatus(10006) // 用户编辑权限
    }
  },
  methods: {
    /**
     * [filterFormSubmit description] 提交筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormSubmit: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getList();
        } else {
          return false;
        }
      });
    },
    /**
     * [filterFormReset description] 重置筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormReset: function (formName) {
      this.$refs[formName].resetFields();
    },
    /**
     * [handleTabsChange description] 切换选项卡
     * @param  {[type]} tab   [description] 取name值用tab.name
     * @param  {[type]} event [description]
     * @return {[type]}       [description]
     */
    handleTabsChange: function (tab, event) {
      this.page.current = 1;
      this.tableData = [];
      this.getList();
    },
    /**
     * [getList description] 获取 tab 列表数据
     * @return {[type]} [description]
     */
    getList: function () {
      if (this.tabName == '1') {
        // 服务订单
        this.getOrderList(2)
      } else if (this.tabName == '2') {
        // 商品订单
        this.getOrderList(1)
      }
    },
    /**
     * [getServiceOrderStatics description] 服务订单统计
     * @return {[type]} [description]
     */
    getServiceOrderStatics: function () {
      const { time, userId } = this.filterForm
      let params = {
        start: time && time.length > 1 ? new Date(time[0]).getTime() : '',
        end: time && time.length > 1 ? (new Date(time[1]).getTime() + 24 * 60 * 60 * 1000 - 1) : '',
        userId
      }
      if (this.id) {
        params.companyId = this.id
      }

      agentServiceOrderStatics(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          const { serviceOrderAmount, serviceOrderNum, serviceOrderIncome } = data
          Object.assign(this.statistics, {
            serviceOrderAmount,
            serviceOrderNum,
            serviceOrderIncome
          })
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
    /**
     * [getProductOrderStatics description] 商品订单统计
     * @return {[type]} [description]
     */
    getProductOrderStatics: function () {
      const { time, userId } = this.filterForm
      let params = {
        start: time && time.length > 1 ? new Date(time[0]).getTime() : '',
        end: time && time.length > 1 ? (new Date(time[1]).getTime() + 24 * 60 * 60 * 1000 - 1) : '',
        userId
      }
      if (this.id) {
        params.companyId = this.id
      }

      agentProductOrderStatics(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          const { productOrderAmount, productOrderNum, productOrderIncome } = data
          Object.assign(this.statistics, {
            productOrderAmount,
            productOrderNum,
            productOrderIncome
          })
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
    /**
     * [getOrderList description] 服务、商品订单列表
     * @return {[type]} [description]
     */
    getOrderList: function (type) {
      this.tableLoading = true;

      const { time, userId } = this.filterForm
      let params = {
        type,
        start: time && time.length > 1 ? new Date(time[0]).getTime() : '',
        end: time && time.length > 1 ? (new Date(time[1]).getTime() + 24 * 60 * 60 * 1000 - 1) : '',
        userId,
        pageNo: this.page.current,
        pageSize: this.page.size
      }
      if (this.id) {
        params.companyId = this.id
      }

      agentOrderList(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          this.tableData = data.records || [];
          this.tableLoading = false;
          this.page.total = data.total;
          this.$nextTick(() => {
            const scrollContainer = document.querySelector('.app-container');
            if (scrollContainer) {
              scrollContainer.scrollTop = 0;
            }
          });
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
    /**
     * [handleSizeChange description] 分页每页条数变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleSizeChange(val) {
      this.page.current = 1;
      this.page.size = val;

      this.getList();
    },
    /**
     * [handleCurrentChange description] 选择分页第几页
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleCurrentChange(val) {
      this.page.current = val;

      this.getList();
    },
    /**
     * [isActiveShortcut description] 判断快捷时间是否选中
     * @param  {[Number]} day [description] 近几日
     * @return {[Boolean]}     [description]
     */
    isActiveShortcut(day) {
      if (!this.filterForm.time || this.filterForm.time.length !== 2) return false;
      const start = COMMON.getDay(day);
      const end = COMMON.getDay(0);
      return this.filterForm.time[0] === start && this.filterForm.time[1] === end;
    },
    /**
     * [getLastFewDays description] 获取近几日日期
     * @param  {[Number]} day [description] 需要获取的近几日的数值
     * @return {[type]}        [description]
     */
    getLastFewDays: function (day) {
      this.filterForm.time = [];
      this.filterForm.time.push(COMMON.getDay(day));
      this.filterForm.time.push(COMMON.getDay(0));
    },
    /**
     * [getList description] 获取表格数据
     * @return {[type]} [description]
     */
    getEmployeeList: function () {
      this.employeeLoading = true;

      let param = {
        'pageNo': 1,
        'pageSize': 99999
      }
      if (this.id) {
        param.companyId = this.id
      }

      agentEmployeeList(param).then(res => {
        this.tableLoading = false;

        let { code, data, msg } = res;

        if (code == 0) {
          this.employeeOptions = data.records || [];
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.employeeLoading = false;
        this.$message.error('服务器异常');
      });
    }
  },
  mounted: function () {
    this.getEmployeeList()
    this.getList();
    this.getServiceOrderStatics()
    this.getProductOrderStatics()
  }
}
</script>

<style lang="scss" scoped>
@import '../../../common/styles/base/_mixin-font';
@import "../../../common/styles/base/mixin-common";

.statistics {
  // margin-top: -10px;
  padding: 20px;
  background: #EFFAFF;
  border-radius: 4px;
  font-size: 0;

  &.default {
    padding: 10px;
    border: 1px solid #D9D9D9;
    background: transparent;

    .item {
      display: inline;
      width: auto;
    }
  }

  .item {
    display: inline-block;
    width: 240px;
    font-size: 12px;
    color: #222222;
    letter-spacing: 0;
    font-weight: 600;

    &+.item {
      margin-left: 80px;
    }
  }
}

.filter-region {
  flex-shrink: 0; // 筛选区域不压缩
  display: flex;
  align-items: center;

  .filter-form {
    flex: 1;

    .el-form-item {
      &.time-shortcut {
        background: initial;
        padding: 0;

        :deep(.el-form-item__content) {
          width: auto;

          .el-button {
            width: 110px;
            height: 40px;
            border-radius: 5px;

            &.is-active {
              border: 1px solid #3388FF;
              color: #3388FF;
              background-color: #ecf5ff;
            }
          }
        }
      }
    }

    // Remove br forcing line breaks in the flex layout
    br {
      display: none;
    }
  }

  .filter-btn {
    height: 100%;

    .btn-group {
      display: flex;

      .btn-reset {
        width: 40px;
        height: 40px;
        border-color: #3388ff;
        color: #3388ff;
      }

      .btn-search {
        width: 84px;
        height: 40px;
      }

      .el-button {
        &+.el-button {
          margin-left: -1px !important;
        }

        &:first-child {
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }

        &:last-child {
          border-top-left-radius: 0 !important;
          border-bottom-left-radius: 0 !important;
        }
      }
    }
  }
}

// .no-margin-top {
//   margin-top: 0;
// }

.mr-10 {
  margin-right: 10px;
}

.mr-20 {
  margin-right: 20px;
}

.pt-pb-10 {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.module-body {
  .text {
    font-size: $smallFS;
    color: $textColor;
    line-height: 27px;
  }

  .avatar {
    position: relative;
    float: left;
    width: 150px;
    height: 150px;
    margin-left: 10px;
    /*background: $colorImgBg;*/

    img {
      max-width: 100%;
      max-height: 100%;
      @include position(absolute, 1, 50%, none, none, 50%);
      @include translate(-50%, -50%, 0);
    }
  }

  .info {
    float: left;
    margin-left: 10px;
  }

  .personal-info-box {
    margin-bottom: 40px;

    .personal-info {
      float: left;
      margin-left: 10px;
    }

    .personal-avatar-info {
      float: left;
      margin-left: 40px;

      .personal-avatar {
        position: relative;
        margin-top: 5px;
        width: 200px;
        height: 130px;
        background: $colorImgBg;

        img {
          max-width: 100%;
          max-height: 100%;
          @include position(absolute, 1, 50%, none, none, 50%);
          @include translate(-50%, -50%, 0);
        }
      }
    }

    .personal-first-avatar-info {
      float: left;
      margin-left: 40px;

      .personal-first-avatar {
        position: relative;
        margin-top: 5px;
        width: 200px;
        height: 130px;
        background: $colorImgBg;

        img {
          max-width: 100%;
          max-height: 100%;
          @include position(absolute, 1, 50%, none, none, 50%);
          @include translate(-50%, -50%, 0);
        }
      }
    }
  }
}
</style>
